// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","menu--flow-vertical":"Menu_menu--flow-vertical__l4a8b","active":"Menu_active__-0Z9R"};